<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-select v-model="keywordType" placeholder="请选择" style="width: 120px;margin-right: 10px;" size="small">
          <el-option label="姓名" :value="1"></el-option>
          <el-option label="正式订单" :value="2"></el-option>
        </el-select>
        <el-input v-model="keyword" placeholder="请输入内容" style="width: 300px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <el-date-picker v-model="today" type="month" placeholder="选择月" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="车间" min-width="100" prop="chejian"></el-table-column>
          <el-table-column align="center" label="姓名" min-width="100" prop="xingming"></el-table-column>
          <el-table-column align="center" label="备料订单" min-width="100" prop="beiliaodingdan"></el-table-column>
          <el-table-column align="center" label="正式订单" min-width="100" prop="zhengshidingdan"></el-table-column>
          <el-table-column align="center" label="产品代码" min-width="100" prop="chanpindaima"></el-table-column>
          <el-table-column align="center" label="产品名称" min-width="100" prop="chanpinmingcheng"></el-table-column>
          <el-table-column align="center" label="单位" min-width="100" prop="danwei"></el-table-column>
          <el-table-column align="center" label="订单数量" min-width="100" prop="dingdanshuliang"></el-table-column>
          <el-table-column align="center" label="部件名称" min-width="100" prop="bujianmingcheng"></el-table-column>
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="日定额标准产量" min-width="100" prop="ridingebzcl"></el-table-column>
          <el-table-column align="center" label="日定额标准工资额" min-width="100" prop="ridingebzgze"></el-table-column>
          <el-table-column align="center" label="标准单件单价" min-width="100" prop="biaozhundjdj"></el-table-column>
          <el-table-column align="center" label="日实际完成数量" min-width="100" prop="rishijiwcsl"></el-table-column>
          <el-table-column align="center" label="日实际完成工资额" min-width="100" prop="rishijiwcgze"></el-table-column>
          <el-table-column align="center" label="标准产量" min-width="100" prop="biaozhunchanliang"></el-table-column>
          <el-table-column align="center" label="计件数量" min-width="100" prop="jijianshuliang"></el-table-column>
          <el-table-column align="center" label="计件单价" min-width="100" prop="jijiandanjia"></el-table-column>
          <el-table-column align="center" label="计件工资" min-width="100" prop="jijiangongzi"></el-table-column>
          <el-table-column align="center" label="异常计时内容" min-width="100" prop="yichangjsnr"></el-table-column>
          <el-table-column align="center" label="异常计时工资额" min-width="100" prop="yichangjsgze"></el-table-column>
          <el-table-column align="center" label="异常计件内容" min-width="100" prop="yichangjjnr"></el-table-column>
          <el-table-column align="center" label="异常计件工资额" min-width="100" prop="yichangjjgze"></el-table-column>
          <el-table-column align="center" label="当日工资额总计" min-width="100" prop="dangrigzezj"></el-table-column>
          <el-table-column align="center" label="成控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="成控总额" min-width="100" prop="chengkongzonge"></el-table-column>
        </el-table>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      today: '',
      sf: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
    
    
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      axios.post(this.$host+'/index.php/admin/Orderexcel/biantengExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '编藤车间报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        // page: this.pageNum,
        // num: this.pageSize,
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      if(this.keyword) {
        data.type = this.keywordType
        data.word = this.keyword
      }
      this.$request.post('/index.php/admin/index/biantengbiao', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
